import React from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import CalendyForm from "../MarketingLandingPage/CalendyForm";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const textHolder = css`
  margin-top: 3.75rem;
  margin-left: auto;
  margin-right: auto;
  @media screen and (min-width: 68.75em) {
    width: 50%;
  }
  @media screen and (min-width: 68.75em) {
    width: 75%;
  }
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const offwhite = css`
  background-color: #f6fbfb;
`;

const col1 = css`
  text-align: center;
`;

const founderImage = css`
  width: 100%;
  /*
  @media only screen and (min-width: 768px) {
    width: 400px;
  }

  @media only screen and (min-width: 900px) {
    width: 480px;
  }
  @media only screen and (min-width: 1200px) {
    width: 60%;
  } */
  @media screen and (min-width: 68.75em) {
    width: 50%;
  }
  @media screen and (min-width: 68.75em) {
    width: 75%;
  }
`;
const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #89d2d3;
  margin: 10px 0px;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

function OurStory({ history }) {
  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "calc(100vh - 70px)",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          <div className={styles.row}>
            <div className={styles.maxWidthWrapper}>
              <styles.H2
                style={{
                  textAlign: "center",
                  width: "100%",
                  margin: "30px 0px",
                }}
              >
                Our <span className={styles.styledUnderline}>Story</span>
              </styles.H2>
            </div>
          </div>

          <div
            className={styles.row}
            style={{
              padding: "0px",
            }}
          >
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <img
                  className={founderImage}
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/Tej-Deep.jpeg"
                  alt="founder-img"
                ></img>
                <div className={textHolder}>
                  <styles.P style={{ textAlign: "left" }}>
                    Hey folks, my name is TJ, founder of Mobile360, and this is
                    my brother, Deep. Here’s our story.
                    <br />
                    <br />
                    👨🏽‍🍳 My brother is a chef and the owner of Masala Fusion, a
                    small home-based business. For 14 years, I personally
                    witnessed the grueling effort required to run a small
                    home-based business, and was shocked at the lack of
                    affordable resources readily available.
                    <br />
                    <br />
                    👨🏽‍💻 Coming from a mobile development background, I knew how
                    powerful having a mobile app could be for his small
                    business.
                    <br />
                    <br />
                    📱 So I built him the Masala Fusion mobile app, and the
                    results were absolutely incredible. With a mobile app, he
                    streamlined all the work he used to manually do and started
                    saving hours every day. It was as if he hired 5 employees to
                    manage all parts of the business! That’s when I thought to
                    myself that every small business in the world can truly
                    benefit from a mobile app.
                    <br />
                    <br />
                    🤝🏽 Today, with Mobile360, any small business owner can
                    customize and launch their mobile app and website to the
                    Mobile360 marketplace in just 30 minutes. But, it’s so much
                    more. Mobile360 is with you to every step of the way - from
                    the day you start your business through the years of your
                    growth. We have a community of incredible entrepreneurs that
                    have gone through what you’re going through and are ready to
                    help. You’re not in this alone. No matter how small your
                    business is, the Mobile360 team and I will help you start
                    and run your business with affordable technology and the
                    support you need.
                    <br />
                    <br />
                    👇🏽 I’m sure you have plenty of questions and I’m happy to
                    personally answer them! Feel free to schedule a time with me
                    below.
                  </styles.P>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.row}>
            {/************************************************************************************************
             *************************************************************************************************
             * Schedule a Demo Row
             * This row is for Calendy Demo scheduling
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <styles.H2
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "30px",
                  }}
                >
                  Schedule a Free 30 Minute{" "}
                  <span className={styles.styledUnderline}>Demo</span>
                </styles.H2>

                <br></br>
                <CalendyForm />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default OurStory;
